<form [formGroup]="form" (ngSubmit)="edit()">
  <div class="big-name-change w-100 h-100">
    <h1 mat-dialog-title class="etn-title">Edit Username</h1>
    <div class="input-change">
      <input type="text" formControlName="newUsername" class="input-text-change" (input)="onInputSpaceChange($event, SharedConstants.NEW_USERNAME)" [value]="data.cardId" >
      @if (form.get('newUsername')?.touched && form.get('newUsername')?.invalid) {
        <div class="error-message">
          @if (form.get('newUsername')?.errors?.['newUsername']) {
            <div>Name is required</div>
          }
          @if (form.get('newUsername')?.errors?.['newUsername']) {
            <div>Invalid username</div>
          }
        </div>
      }
      @if (errorMessage) {
        <div class="error-message">{{ errorMessage }}</div>
      }
    </div>
    <div class="option-select">
      <button mat-button class="cancel-btn shared-btn" type="button" (click)="onNoClick()">Cancel</button>
      <button mat-button class="save-btn shared-btn" type="submit">Save</button>
    </div>
  </div>
</form>
